import { useContext } from 'react'
import NoneAnchor from 'components/NoneAnchor'
import { removeFilter } from 'features/dashboard/filter/dashboardFilterSlice'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import { batch, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import FilterName from 'features/dashboard/filter/FilterName'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const FilterChip = ({ filter }) => {
  const dispatch = useDispatch()
  const { editable } = useSelector(state => state.dashboard.table.keywordTable)
  const { showFilterFormLayer } = useContext(FilterContext)
  const { domain, key, data } = filter
  return (
    <li>
      <div className="box_adsearch">
        <NoneAnchor
          className="btn_adsearch"
          style={editable ? { pointerEvents: 'none' } : undefined}
          onClick={() => {
            if (!editable) {
              showFilterFormLayer(filter)
            }
          }}>
          <FilterName
            domain={domain}
            type={key}
            data={data}
            tooltip={!editable}
          />
        </NoneAnchor>
        <NoneAnchor
          className="btn_del"
          style={editable ? { pointerEvents: 'none' } : undefined}
          onClick={() => {
            if (!editable) {
              batch(() => {
                dispatch(removeFilter(filter))
                dispatch(campaignTableActions.setPage(0))
                dispatch(adGroupTableActions.setPage(0))
                dispatch(keywordTableActions.setPage(0))
                dispatch(creativeTableActions.setPage(0))
              })
            }
          }}>
          <span className="ico_comm ico_del">삭제</span>
        </NoneAnchor>
      </div>
    </li>
  )
}
FilterChip.propTypes = {
  filter: PropTypes.object,
}
export default FilterChip
